import {useState, useEffect} from "react";

import { DynamicFormTemplate } from "../../utilities";
import { useTranslation } from 'react-i18next';

const ConclusionForm = (props) => {
    const { t: translate } = useTranslation();
    const {
        isHidden,
        formData,
        error
    } = props

    const [selectForm, setSelectForm] = useState([])
    const [idForm, setIdForm] = useState([])
    const [errorInput, setErrorInput] = useState({})

    const seperateForm = () => {
        const select = []
        const id = []

        select.push(formData[0])
        formData.forEach((element, index) => {
            if(index !== 0){
                id.push(element)
            }
        })

        setSelectForm(select)
        setIdForm(id)
    }

    useEffect(() => {
        seperateForm()
    }, [])

    useEffect(() => {
        if(error.length > 0){
            let errorInputTemp = {}
            error.forEach(e => {
                errorInputTemp = {...errorInputTemp, [e]: true}
            })
            setErrorInput(errorInputTemp)
            seperateForm()
        }
    }, [error])

    return <div style={{ display: isHidden ? "none" : "block" }}>
        <div className="form-container">
            <p className="bold form-group">{translate('conclusionOfControl')}</p>
            {selectForm.length > 0 ? <DynamicFormTemplate isHidden={false} formData={selectForm} defaultValue={{}} error={errorInput} /> : null}
            {idForm.length > 0 ? <DynamicFormTemplate isHidden={false} formData={idForm} defaultValue={{}} error={errorInput} /> : null}
        </div>
    </div>
}

export default ConclusionForm;